/**
 * Shared period-filter helpers used by every dashboard section filter
 * (Transactions, Journal Entries, Ledger, Trial Balance). Extracted from
 * DashboardPage.js so all sections compute date ranges identically.
 */

export const dateFilterOptions = [
  { value: 'overall', label: 'Overall' },
  { value: 'today', label: 'Today' },
  { value: 'last7', label: 'Last 7 Days' },
  { value: 'last15', label: 'Last 15 Days' },
  { value: 'last30', label: 'Last 30 Days' },
  { value: 'thisMonth', label: 'This Month' },
  { value: 'lastMonth', label: 'Last Month' },
  { value: 'thisFY', label: 'This Financial Year' },
  { value: 'lastFY', label: 'Last Financial Year' },
  { value: 'custom', label: 'Custom Range' },
];

export const toISODate = (date) => {
  if (!(date instanceof Date)) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export const computeRangeForFilter = (filter) => {
  const today = new Date();
  const current = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  switch (filter) {
    case 'today':
      return { from: toISODate(current), to: toISODate(current) };
    case 'last7': {
      const f = new Date(current); f.setDate(f.getDate() - 6);
      return { from: toISODate(f), to: toISODate(current) };
    }
    case 'last15': {
      const f = new Date(current); f.setDate(f.getDate() - 14);
      return { from: toISODate(f), to: toISODate(current) };
    }
    case 'last30': {
      const f = new Date(current); f.setDate(f.getDate() - 29);
      return { from: toISODate(f), to: toISODate(current) };
    }
    case 'thisMonth': {
      const f = new Date(current.getFullYear(), current.getMonth(), 1);
      return { from: toISODate(f), to: toISODate(current) };
    }
    case 'lastMonth': {
      const year = current.getMonth() === 0 ? current.getFullYear() - 1 : current.getFullYear();
      const month = current.getMonth() === 0 ? 11 : current.getMonth() - 1;
      const f = new Date(year, month, 1);
      const t = new Date(year, month + 1, 0);
      return { from: toISODate(f), to: toISODate(t) };
    }
    // Indian financial year: 1 April – 31 March.
    case 'thisFY': {
      const fyStart = current.getMonth() >= 3 ? current.getFullYear() : current.getFullYear() - 1;
      return { from: toISODate(new Date(fyStart, 3, 1)), to: toISODate(current) };
    }
    case 'lastFY': {
      const fyStart = (current.getMonth() >= 3 ? current.getFullYear() : current.getFullYear() - 1) - 1;
      return { from: toISODate(new Date(fyStart, 3, 1)), to: toISODate(new Date(fyStart + 1, 2, 31)) };
    }
    default:
      return { from: '', to: '' };
  }
};
